import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { CircleX } from "lucide-react";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

export default function CreateInvite() {
  const { surveyId } = useParams();
  const navigate = useNavigate(); // För navigering till andra sidor

  const [customerName, setCustomerName] = useState("");
  const [urllink, setUrllink] = useState("");
  const [email, setEmail] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [officeId, setOfficeId] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [infoText, setInfoText] = useState("");
  const [contactInfo, setContactInfo] = useState("");

  const [formData, setFormData] = useState("");

  const tenantId = getTenantIdFromHost();

  //   function generateToken() {
  //     return Math.random().toString(36).substring(2, 12);
  //   }

  useEffect(() => {
    (async () => {
      try {
        const formRef = doc(db, "tenants", tenantId, "forms", surveyId);
        const formSnap = await getDoc(formRef);

        if (!formSnap.exists()) {
          throw new Error("Formuläret hittades inte.");
        }

        setFormData(formSnap.data());
      } catch (e) {
        console.error("Failed to load formData", e);
      }
    })();
  }, [surveyId, tenantId]);

  function generateToken() {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return btoa(String.fromCharCode(...bytes))
      .replaceAll("+", "-")
      .replaceAll("/", "_")
      .replaceAll("=", "");
  }

  const createInvite = async (data) => {
    const token = generateToken();

    await setDoc(doc(db, "tenants", tenantId, "surveyInvites", token), {
      ...data,
      status: "open",
      createdAt: serverTimestamp(),
    });

    //Nolla fälten??
    //knapp disable
    return `${window.location.origin}/feedback/${token}`;
  };

  const handleCreate = async () => {
    if (!customerPhone.startsWith("+46") || customerPhone.length < 10) {
      setInfoText("Kontrollera telefonnummer, ska börja med +46 ");
        return;
    }
    if (
      !surveyId ||
      !customerName ||
      !email ||
      !employeeId ||
      !officeId ||
      !customerId
    ) {
      setInfoText("Något saknas i formuläret");
      return;
    }
    const link = await createInvite({
      surveyId,
      customerName,
      email,
      employeeId,
      officeId,
      customerId,
      customerPhone: formatPhoneNumber(customerPhone),
      formName: formData.formName || "",
      questions: formData.questions || [],
    });
    setUrllink(link);
    setEmail("");
    setCustomerPhone("");
    setCustomerId("");
    setCustomerName("");
    setEmployeeId("");
    setOfficeId("");

    //Sätta en riktig länk här?? Vill man det?
    setInfoText("Länk skapad:\n" + link);
    setContactInfo(
      "Kundens tilltalsnamn: " + customerName + " Kundens e-post: " + email,
    );
  };

  const copyLink = () => {
    navigator.clipboard.writeText(urllink);
  };

  const handleCloseForm = () => {
    navigate(`/survey`);
    //navigate(-1);
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";

    let cleaned = phone.replace(/\s+/g, ""); // ta bort mellanslag

    // redan korrekt format
    if (cleaned.startsWith("+")) return cleaned;

    // 0046 → +46
    if (cleaned.startsWith("0046")) {
      return "+" + cleaned.substring(2);
    }

    // 070 → +4670
    if (cleaned.startsWith("0")) {
      return "+46" + cleaned.substring(1);
    }

    // 70 → +4670
    if (cleaned.startsWith("7")) {
      return "+46" + cleaned;
    }

    return cleaned;
  };

  return (
    <div className="formBuilderWrapper">
      <button className="plainButton" onClick={handleCloseForm}><CircleX size={36} strokeWidth={2} color="#333"/></button>
      <h2>Skapa inbjudan till formulär</h2>
      <h4>Synligt i formulär och inbjudan</h4>
      <label>Kundens tilltalsnamn</label>
      <input
        type="text"
        placeholder="Namn"
        value={customerName}
        onChange={(e) => setCustomerName(e.target.value)}
      />

      <label>Kontor ID</label>
      <input
        type="text"
        placeholder="Kontor ID"
        value={officeId}
        onChange={(e) => setOfficeId(e.target.value)}
      />
      <hr />

      <h4>Kontaktuppgifter till kunden</h4>

      <label>Kundens telefonnummer</label>
      <input
        type="tel"
        placeholder="telefon"
        value={customerPhone}
        onChange={(e) => setCustomerPhone(e.target.value)}
      />

      <label>Kundens e-post</label>
      <input
        type="email"
        placeholder="E-post"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <hr />

      <h4>INTE synligt i formuläret</h4>
      <label>Internt Kund ID</label>
      <input
        type="text"
        placeholder="Kund ID"
        value={customerId}
        onChange={(e) => setCustomerId(e.target.value)}
      />
      <label>Ansvarig handläggare ID</label>
      <input
        type="text"
        placeholder="Ansvarig handläggare ID:"
        value={employeeId}
        onChange={(e) => setEmployeeId(e.target.value)}
      />

      <button onClick={handleCreate}>Skapa enkätlänk</button>

      <hr />

      {infoText ? (
        <>
          <h3>{infoText}</h3>
          {"\n"}
          <h3>{contactInfo}</h3>
          <button onClick={() => copyLink()}>Kopiera länk</button>
        </>
      ) : null}
    </div>
  );
}
